<template>
    <div class="main report">

        <div class="report-heading">
            <div style="position: relative;">
                <h1 class="breadcrumb" @click="clearFilters()">Manufacturer Performance Review <span style="font-size: 0.5em;">Sales, Margin &amp; Turnover</span></h1>
                <h2>
                    <router-link v-if="manufacturer_id" class="breadcrumb" :to="'/manufacturers/' + department_id">{{ department_name }}</router-link>
                    <span v-else>{{ department_name }}</span>
                    <i v-if="manufacturer_name" class="fas fa-chevron-right" style="font-size: 0.9em; padding: 0 0.5em;"></i>
                    <span>{{ manufacturer_name }}</span>
                </h2>
            </div>
            <div v-if="notEmpty(totals)" class="report-total">
                <div>
                    <label>Total Sales Cost</label><br>{{ formatCurrency(totals.cost) }}
                </div>
                <div>
                    <label>Total Sales Retail</label><br>{{ formatCurrency(totals.price) }}
                </div>
                <div>
                    <label>Total Margin</label><br>{{ totals.margin }}
                </div>
            </div>
        </div>

        <div class="filters with-compare">
            <div class="three-columns selectors">
                <label>UPC / SKU</label>
                <label v-if="showDealerFilter">Dealer</label>
                <label v-else></label>
                <label></label>
                <div class="input-with-control">
                    <input class="sales" type="search" v-model="filters.search_text" placeholder="Search..." @keyup.enter="setFilter('search_text')">
                    <div class="button sales input-go" @click="setFilter('search_text')"><i class="fas fa-search"></i></div>
                    <div v-if="itemSearchList.length > 0" class="search-list">Message or list</div>
                </div>
                <div v-if="showDealerFilter" class="input-with-control">
                    <input class="sales" type="text" v-model="filters.location_name" placeholder="Search..." @keyup.enter="setFilter('location')">
                    <div class="button sales input-go" @click="setFilter('location')"><i class="fas fa-search"></i></div>
                    <div v-if="dealerSearchList.length > 0 || dealerSearchMessage" class="search-list">
                        <div v-for="dealer in dealerSearchList" class="search-list-item" :key="dealer.location_id" @click="setFilterFromSearch(location)">{{ dealer.description }}</div>
                        <div v-if="dealerSearchMessage">{{ dealerSearchMessage }}</div>
                    </div>
                </div>
                <div v-else></div>
            </div>
            <div>
                <div class="input-with-control date-control">
                    <label>Start</label>
                    <label>End</label>
                    <label></label>
                    <input class="sales" type="date" :min="minFilterDate" :max="maxFilterDate" v-model="filters.start_date" required="required">
                    <input class="sales" type="date" :min="minFilterDate" :max="maxFilterDate" v-model="filters.end_date" required="required">
                    <div class="button sales input-go" @click="setFilterDates()"><i class="fas fa-calendar-check"></i></div>
                </div>
            </div>
            <div>
                <div class="button sales compare-button" @click="showCompare = true"><i class="fas fa-calendar-plus"></i></div>
            </div>
        </div>

        <template v-if="!loading">
            <div v-if="totals.price && chartData.series && filters.manufacturer_id" >
                <div style="display: grid; grid-template-columns: 1.5fr 2fr 5em; margin: 0 12em 0.25em 0;">
                    <label></label>
                    <label>% of {{ manufacturer_name }} Sales</label>
                    <div style="position: relative;">
                        <label style="position: absolute; width: 10em; left: 1em;">{{ department_name }} Rank</label>
                    </div>
                </div>
                <div v-for="(sales, index) in chartData.series[0]" style="display: grid; grid-template-columns: 1.5fr 2fr 5em; margin: 0 12em 0.25em 0;">
                    <div style="text-align: right; padding: 0 0.5em 0 0;">{{ chartData.labels[index] }}</div>
                    <div :style="'position: relative; float: left; height: 1.66em; background-color: #038E18; color: #ffffff; padding: 0.15em 0 0 0.5em; width: ' + (((sales / totals.price) * 100) / (chartData.series[0][0] / totals.price)) + '%;'">
                        <span style="position: absolute; left: 0.33em; top: 0.33em; font-size: 0.8em; color: #ffffff;">{{ ((sales / totals.price) * 100).toFixed(1) }}%</span>
                        <!-- <div :style="'float: right; margin-right: -' + (chartData.sales_rank[index].toString().length + 1) + 'em;'">#{{ chartData.sales_rank[index] }}</div> -->
                    </div>
                </div>
            </div>
            <div v-else-if="totals.price && chartData.series && filters.department_id" class="two-columns">
                <div>
                    <div v-for="(sales, index) in chartData.series[0]" style="display: grid; grid-template-columns: 1fr 1.5fr; margin: 0 6em 0.25em 0;">
                        <div style="text-align: right; padding: 0 0.5em 0 0;">{{ chartData.labels[index] }}</div>
                        <div :style="'position: relative; float: left; height: 1.66em; background-color: #038E18; color: #ffffff; width: ' + (((sales / totals.price) * 100) / (chartData.series[0][0] / totals.price)) + '%;'">
                            <span style="position: absolute; left: 0.33em; top: 0.33em; font-size: 0.8em; color: #ffffff;">{{ ((sales / totals.price) * 100).toFixed(1) }}%</span>
                            <div :style="'float: right; margin-right: -' + (chartData.series[0][index].toString().length - 2) + 'em;'">${{ formatCurrency(chartData.series[0][index]) }}</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div v-for="(sales, index) in chartData.sales_series[0]" style="display: grid; grid-template-columns: 1.5fr 1fr 5em; margin: 0 0 0.25em 0;">
                        <div style="text-align: right; padding: 0 0.5em 0 0;">{{ chartData.sales_labels[index] }}</div>
                        <div :style="'position: relative; float: left; height: 1.66em; background-color: #038E18; color: #ffffff; padding: 0.15em 0 0 0.5em; width: ' + (((sales / totals.price) * 100) / (chartData.sales_series[0][0] / totals.price)) + '%;'">
                            <span style="position: absolute; left: 0.33em; top: 0.33em; font-size: 0.8em; color: #ffffff;">{{ ((sales / totals.price) * 100).toFixed(1) }}%</span>
                            <!-- <div :style="'float: right; margin-right: -' + (chartData.sales_sales_rank[index].toString().length + 1) + 'em;'">#{{ chartData.sales_sales_rank[index] }}</div> -->
                        </div>
                    </div>
                </div>
            </div>

        </template>

        <div v-if="message" class="empty-list">
            {{ message }}
            <div v-if="loading" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
        </div>

        <div v-if="!loading && emptyLists" class="empty-list">This list is empty</div>

        <template v-if="!loading">
            <div v-for="(list, section) in lists" :key="section" class="report-list department">
                <div v-if="list.length > 0" :class="['report-row', {'report-row-extra': filters.manufacturer_id}, 'heading']">
                    <h2>{{ sectionTitle(section) }}</h2>
                    <label :class="['right', { sortable: department_id }, { sortcurrent: department_id && filters.sort_column == 'on_hand' }]" @click="setSort('on_hand')">Units<br>On Hand<span v-html="showSort('on_hand')"></span></label>
                    <label :class="['right', { sortable: department_id }, { sortcurrent: department_id && filters.sort_column == 'price_on_hand' }]" @click="setSort('price_on_hand')">Retail<br>On Hand<span v-html="showSort('price_on_hand')"></span></label>
                    <label :class="['right', { sortable: department_id }, { sortcurrent: department_id && filters.sort_column == 'received' }]" @click="setSort('received')">Units<br>Received<span v-html="showSort('received')"></span></label>
                    <label :class="['right', { sortable: department_id }, { sortcurrent: department_id && filters.sort_column == 'sold' }]" @click="setSort('sold')">Units<br>Sold<span v-html="showSort('sold')"></span></label>
                    <label :class="['right', { sortable: department_id }, { sortcurrent: department_id && filters.sort_column == 'price_sold' }]" @click="setSort('price_sold')">Retail<br>Price Sold<span v-html="showSort('price_sold')"></span></label>
                    <label :class="['right', { sortable: department_id }, { sortcurrent: department_id && filters.sort_column == 'profit_sold' }]" @click="setSort('profit_sold')">Profit<span v-html="showSort('profit_sold')"></span></label>
                    <label class="right">Margin</label>
                    <label class="right">Turnover</label>
                    <label class="right">% of<br>Sales</label>
                    <label v-if="filters.manufacturer_id" class="right">Dept<br>Rank</label>
                </div>
                <div :class="['report-row', {'report-row-extra': filters.manufacturer_id}]" v-for="(data, index) in list" :key="index">
                    <div class="two-columns row-controls">
                        <div>
                            <div class="row-title">{{ data.description }}</div>
                            <div v-if="data.product_id">
                                <label>UPC</label><span class="caption">{{ data.upc }}</span>
                                <label>ID</label><span class="caption">{{ data.product_id }}</span>
                            </div>
                        </div>
                        <div>
                            <div v-if="data.sold > 0" class="button sales" @click="getListItems(data)"><i class="fas fa-list"></i></div>
                            <div v-else class="button disabled"><i class="fas fa-list"></i></div>
                        </div>
                    </div>
                    <div>
                        <span class="numbers full">{{ formatInteger(data.on_hand) || "&nbsp;" }}</span>
                    </div>
                    <div>
                        <span class="numbers full">{{ formatCurrency(data.price_on_hand) }}</span>
                    </div>
                    <div>
                        <span class="numbers full">{{ formatInteger(data.received) }}</span>
                    </div>
                    <div>
                        <span class="numbers full">{{ formatInteger(data.sold) || "&nbsp;" }}</span>
                    </div>
                    <div>
                        <span class="numbers full">{{ formatCurrency(data.price_sold) }}</span>
                    </div>
                    <div>
                        <span class="numbers full">{{ formatCurrency(data.profit_sold) }}</span>
                    </div>
                    <div>
                        <span class="numbers full">{{ data.margin_sold }}</span>
                    </div>
                    <div>
                        <span class="numbers full">{{ data.turnover }}</span>
                    </div>
                    <div>
                        <span class="numbers full">{{ ((data.price_sold / totals.price) * 100).toFixed(1) }}</span>
                    </div>
                    <div v-if="data.sales_rank">
                        <span class="numbers full">{{ data.sales_rank }}</span>
                    </div>
                </div>

                <pagination v-if="section == 'items' && showPagination" :paging="paging" @updatePage="goToPage"></pagination>

            </div>

            <div class="disclaimer">The COMPASS Teradata System is provided by the National Shooting Sports Network for the exclusive use of our subscribers. The data is a sample of the entire market and not meant to represent all sales across the shooting sports industry. Through the COMPASS Teradata System, NSSN is not offering advice or analysis, financial or otherwise, but rather providing information based on the compiled data. Total sales and inventory estimates are based on Compass’s projected percentage of total industry retail sales size, not manufacturer total production size. Margin, turnover and percent of sales are based on real time dealer data.</div>

        </template>

        <compare-dates :active="showCompare" :section="'sales'" @cancel="showCompare = false" />

    </div>
</template>
<script>
export default {
    name: 'sales',
    props: ['department_id', 'manufacturer_id'],
    data() {
        return {
            loading: true,
            loadingChart: false,
            message: '',
            filters: {
                section: 'sales',
                start_date: '',
                end_date: '',
                department_id: '',
                department_type: '',
                manufacturer_id: '',
                manufacturer_name: '',
                search_text: '',
                location_id: '',
                location_name: '',
                filter_by_list: '',
                page: 1,
                sort_column: '',
                sort_descending: true
            },
            totals: {},
            lists: {
                firearms: [],
                non_firearms: [],
                items: []
            },
            paging: {},
            department_name: '',
            manufacturer_name: '',
            manufacturerSearchList: [],
            manufactuerSearchMessage: '',
            itemSearchList: [],
            itemSearchMessage: '',
            dealerSearchList: [],
            dealerSearchMessage: '',
            minFilterDate: '',
            maxFilterDate: '',
            showCompare: false,
            chartType: 'Bar',
            chartData: {},
            chartDataSecondary: {},
            chartOptions: {
                fullWidth: true,
                horizontalBars: true,
                reverseData: true,
                height: 250,
                width: '90%',
                axisX: {
                    showLabel: false,
                    showGrid: false
                },
                axisY: {
                    offset: 200,
                    showGrid: false
                },
                classNames: {
                    label: 'bigger-ct-label'
                }
            }
        }
    },
    created() {
        // any filters previously stored for this section?
        if (this.getFilters.section == 'manufacturers') {
            this.filters = this.getFilters // filters were stored last time we hit fetchDataItems()
        }
        if (!this.filters.sort_column) {
            this.filters.sort_column = 'price_sold'
        }
        this.filters.start_date = this.getQueryString('start') || this.getYearStartDate()
        this.filters.end_date = this.getQueryString('end') || this.getYesterdaysDate()
        this.minFilterDate = this.filters.start_date.split('-').shift() + '-01-01'
        this.maxFilterDate = this.filters.end_date.split('-').shift() + '-12-31'
        if (this.manufacturer_id) {
            this.filters.department_id = this.department_id
            this.filters.manufacturer_id = this.manufacturer_id
            this.fetchChartData()
            this.fetchDataItems()
        } else if (this.department_id) {
            this.filters.department_id = this.department_id
            this.fetchChartData()
            this.fetchDataManufacturer()
        } else {
            this.filters.department_id = ''
            this.fetchData()
        }
    },
    computed: {
        showPagination() {
            return this.department_id && this.lists.items.length > 0 && this.paging.total_pages > 1
        },
        showDealerFilter() {
            return false; // this.getUser && this.getUser.user_type_code && this.getUser.user_type_code.indexOf('ADMIN') > -1
        },
        emptyLists() {
            return this.lists.firearms.length + this.lists.non_firearms.length + this.lists.items.length == 0
        }
    },
    methods: {
		fetchData() {
            this.loading = true
            this.totals = {}
            this.message = 'Loading departments...'
            let apiAction = 'get_report_manufacturer_departments'
            if (this.filters.start_date != this.getYearStartDate()) {
                this.message = this.message + ' custom date report'
            }
            this.apiCall({ destination: apiAction, data: this.filters }).then(obj => {
                this.loading = false
                if (obj.status == 'success') {
                    this.storeFilters(this.filters) // store current filter set
                    this.lists.firearms = obj.firearms
                    this.lists.non_firearms = obj.non_firearms
                    this.lists.items = []
                    this.totals = obj.totals
                    this.message = ''
                    window.scrollTo(0,0);
                } else {
                    this.message = obj.message
                }
            })
        },
        setFilterDates() {
            this.$router.push({ path: this.$route.path , query: { start: this.filters.start_date, end: this.filters.end_date } })
        },
        sectionTitle(section) {
            switch (section) {
                case 'firearms':
                    return 'Firearms'
                case 'non_firearms':
                    return 'Accessories'
                case 'non_inventory':
                    return 'Non-Inventory'
                case 'items':
                    return this.department_name
            }
        },
        getListItems(data) {
            this.totals = {
                cost: data.cost_sold,
                price: data.price_sold,
                margin: data.margin_sold
            }
            this.storeTotals(this.totals)
            if (data.manufacturer_id) {
                this.$router.push({path: '/manufacturers/' + this.filters.department_id + '/' + data.manufacturer_id, props: { manufacturer_id: data.manufacturer_id }, query: this.$route.query})
            } else if (data.department_id) {
                this.$router.push({path: '/manufacturers/' + data.department_id, query: this.$route.query})
            } else if (data.product_id) {
                this.$router.push({path: '/item/manufacturers/' + data.product_id, query: this.$route.query})
            }
        },
        goToPage(page) {
			this.paging.current_page = page
			this.setFilter('page')
		},
        showSort(column) {
            if (!this.filters.department_id) {
                return
            }
            if (this.filters.sort_column == column) {
                if (this.filters.sort_descending) {
                    return "<i class='fas fa-caret-down'></i>"
                } else {
                    return "<i class='fas fa-caret-up'></i>"
                }
            } else {
                return "&nbsp;"
            }
        },
        setSort(which) {
            //only sort if drilled down on a department and we're not already loading
            if (!this.department_id) { return }
            if (this.loading) { return }
            if (this.filters.sort_column == which) {
                this.filters.sort_descending = !this.filters.sort_descending
            } else {
                this.filters.sort_column = which
            }
            this.setFilter('sort')
        },
        setFilter(which, action) {
            switch (which) {
                case 'page':
                    this.filters.page = this.paging.current_page
                    if (this.manufacturer_id) {
                        this.fetchDataItems()
                    } else {
                        this.fetchDataManufacturer()
                    }
                    return false;
                case 'manufacturer':
                    this.manufacturerSearchList = []
                    this.manufactuerSearchMessage = ''
                    if (action == 'clear') {
                        this.filters.manufacturer_name = ''
                        this.filters.manufacturer_id = ''
                        this.filter_by_list = ''
                        if (this.filters.search_text) {
                            this.fetchDataItems()
                        } else {
                            this.fetchData()
                        }
                    } else {
                        this.searchFilter('manufacturer')
                    }
                    return false
                case 'search_text':
                    if (this.filters.search_text) {
                        this.fetchDataItems()
                    } else {
                        this.fetchData()
                    }
                    return false
            }
            if (this.manufacturer_id) {
                this.filters.department_id = this.department_id
                this.filters.manufacturer_id = this.manufacturer_id
                this.fetchDataItems()
            } else if (this.department_id) {
                this.filters.department_id = this.department_id
                this.fetchDataManufacturer()
            }
        },
        clearFilters() {
            this.filters = {
                section: 'sales',
                start_date: '',
                end_date: '',
                department_id: '',
                department_type: '',
                manufacturer_id: '',
                manufacturer_name: '',
                search_text: '',
                location_id: '',
                location_name: '',
                filter_by_list: '',
                page: 1,
                sort_by: 'price_sold'
            }
            this.filters.start_date = this.getQueryString('start') || this.getYearStartDate()
            this.filters.end_date = this.getQueryString('end') || this.getYesterdaysDate()
            this.message = ''
            this.department_name = ''
            if (this.$route.path != '/manufacturers') {
                // pushing route will clear id
                this.$router.push({path: '/manufacturers', query: this.$route.query})
            } else {
                // but if base route already, reload data
                this.fetchData()
            }
        },
        searchFilter(which) {
            this.filters.filter_by_list = which
            this.apiCall({ destination: 'get_filter_list', data: this.filters }).then(obj => {
                if (obj.status == 'success') {
                    if (obj.filter_list.length == 1) {
                        this.filters.manufacturer_name = obj.filter_list[0]['description']
                        this.filters.manufacturer_id = obj.filter_list[0]['manufacturer_id']
                        this.fetchDataItems()
                    } else if (obj.filter_list.length > 1) {
                        this.manufacturerSearchList = obj.filter_list
                    } else {
                        this.manufactuerSearchMessage = 'Manufacturer not found'
                        setTimeout(() => { this.manufactuerSearchMessage = '' }, 2000)
                    }
                } else {
                    this.message = obj.message
                }
            })
        },
        setFilterFromSearch(data) {
            if (this.filters.filter_by_list == 'manufacturer') {
                this.manufacturerSearchList = []
                this.manufactuerSearchMessage = ''
                this.filters.manufacturer_name = data.description
                this.filters.manufacturer_id = data['manufacturer_id']
            }
            if (this.filters.filter_by_list == 'location') {
                this.dealerSearchList = []
                this.dealerSearchMessage =  ''
                this.filters.location_name = data.description
                this.filters.location_id = data['location_id']
            }
            this.fetchDataItems()
        },
        fetchChartData() {
            if (this.loadingChart) { return }
            this.loadingChart = true
            this.chartData = {}
            let destination = this.manufacturer_id ? 'get_manufacturer_item_chart_data' : 'get_manufacturer_chart_data'
            this.apiCall({ destination: destination, data: this.filters }).then(obj => {
                this.loadingChart = false
                if (obj.status == 'success') {
                    this.chartOptions.height = obj.chart_data.labels.length * 33
                    this.chartOptions.axisY.offset = this.manufacturer_id ? 400 : 300
                    this.chartData = obj.chart_data
                }
            })
        },
        fetchDataManufacturer() {
            this.lists.items = []
            this.loading = true
            this.message = 'Loading manfuacturers...'
            if (this.filters.start_date != this.getYearStartDate()) {
                this.message = this.message + ' custom date report'
            }
            this.apiCall({ destination: 'get_report_manufacturers', data: this.filters }).then(obj => {
                this.loading = false
                if (obj.status == 'success') {
                    this.storeFilters(this.filters) // store current filter set
                    window.scrollTo(0,0);
                    this.department_name = obj.department_name
                    this.filters.department_type = obj.department_type
                    if (obj.items.length > 0) {
                        this.lists.items = obj.items
                        //this.totals = this.getTotals
                        this.totals = obj.totals
                        this.paging = obj.paging
                        this.message = ''
                    } else {
                        this.message = 'Items not found'
                        setTimeout(() => { this.message = '' }, 2000)
                    }
                } else {
                    this.message = obj.message
                    setTimeout(() => { this.message = '' }, 2000)
                }
            })
        },
        fetchDataItems() {
            this.totals = {}
            this.lists.items = []
            this.loading = true
            this.message = 'Loading items...'
            if (this.filters.start_date != this.getYearStartDate()) {
                this.message = this.message + ' custom date report'
            }
            this.apiCall({ destination: 'get_report_manufacturer_items', data: this.filters }).then(obj => {
                this.loading = false
                if (obj.status == 'success') {
                    this.storeFilters(this.filters) // store current filter set
                    window.scrollTo(0,0);
                    this.department_name = obj.department_name
                    this.filters.department_type = obj.department_type
                    this.manufacturer_name = obj.manufacturer_name
                    this.lists.firearms = []
                    this.lists.non_firearms = []
                    this.lists.non_inventory = []
                    if (obj.items.length > 0) {
                        this.lists.items = obj.items
                        //this.totals = this.getTotals
                        this.totals = obj.totals
                        this.paging = obj.paging
                        this.message = ''
                    } else {
                        this.message = 'Items not found'
                        setTimeout(() => { this.message = '' }, 2000)
                    }
                } else {
                    this.message = obj.message
                    setTimeout(() => { this.message = '' }, 2000)
                }
            })
        },
        getItem(productId) {
            this.$router.push('/item/' + productId)
        }
    }
}
</script>
<style lang="scss" scoped>
.report-row {
    grid-template-columns: 2.5fr 0.5fr 1fr 0.5fr 0.5fr 1fr 1fr 0.5fr 0.5fr 0.5fr;
}
.report-row-extra {
    grid-template-columns: 2.5fr 0.5fr 1fr 0.5fr 0.5fr 1fr 1fr 0.5fr 0.5fr 0.5fr 0.5fr;
}
.row-controls {
    grid-template-columns: 3fr 1fr;
    label { width: auto; padding: 0 0.5em 0 0.5em; }
}
</style>
